import { useLocation } from 'react-router-dom'
import { HomeHeroLoader } from './HomeHeroLoader'
import { HeroSkeleton } from './HeroSkeleton'

/**
 * Route-aware loading fallback for React.Suspense.
 * Shows a full-screen hero loader on the home page,
 * and a global hero skeleton on all other pages.
 */
export function RouteLoadingFallback() {
  const location = useLocation()
  
  // Home page gets the full hero loader
  if (location.pathname === '/') {
    return <HomeHeroLoader />
  }
  
  // All other pages get the hero skeleton
  return (
    <main className="min-h-screen bg-background">
      <HeroSkeleton />
    </main>
  )
}
